import { connect, type ConnectedProps } from 'react-redux';
import copy from 'copy-to-clipboard';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import dedent from 'dedent';
import { WIDGET_URL } from '@/config';
import { openSnackbar } from '@/core/features/snackbar';
import { ModalLayout } from '../../layouts';
import { type ModalContentProps } from '../../../state';

type Props = ModalContentProps & ConnectedProps<typeof connector>;

const EmbedEventModal = ({
  closeModal,
  modalData: { eventId },
  openSnackbar,
}: Props) => {
  const code = dedent`
    <div id="sport-widget-feed"></div>
    <script src="${WIDGET_URL}/sport-widget-feed.umd.cjs"></script>
    <script>
      window.renderSportWidgetFeed('sport-widget-feed', {
        eventId: '${eventId}',
      });
    </script>
  `;

  const handleCopy = () => {
    copy(code);
    openSnackbar({
      snackbarMessage: 'Copied to clipboard',
      snackbarType: 'success',
    });
    closeModal();
  };

  return (
    <ModalLayout
      closeModal={closeModal}
      title="Embed Event"
      onAccept={handleCopy}
      acceptText="Copy"
      onCancel={closeModal}
      cancelText="Cancel"
    >
      <SyntaxHighlighter style={vs}>{code}</SyntaxHighlighter>
    </ModalLayout>
  );
};

const connector = connect(null, {
  openSnackbar,
});

export default connector(EmbedEventModal);
